export default "__VITE_ASSET__7695290e__"